export default [
    {
        "id":"31",
        "name":"Contracts",
        "slug": "envelopes",
        "parents_id":"0",
        "menu_order":null,
        "show":"1",
        "show_create": true,
        "show_bulk_actions": false
    }
]
